import { TableClassKey } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const MuiTable: Record<TableClassKey, CSSProperties> = {
  root: {},
  stickyHeader: {},
};
